import '.a{display:flex;}.ssr-plugin'
import '.s{flex-direction:row;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.by{height:100vh;}.ssr-plugin'
import '.ap{flex-grow:1;}.ssr-plugin'
import '.aa{min-width:0px;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.c3{overflow-y:auto;}.ssr-plugin'
import '.fs{margin-top:2rem;}.ssr-plugin'
import '.d5{min-height:0px;}.ssr-plugin'
import '.gm{max-width:60rem;}.ssr-plugin'
import '.gn{margin-left:auto;}.ssr-plugin'
import '.go{margin-right:auto;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { InitiativeSideBar } from '@app/components/blocks/sidebar/InitiativeSideBar'
import { ClientOnly } from '@based/sdk/react'
import Column from '@app/components/layout/Column'

export const InitiativeViewPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Column alignItems="stretch">
        <div className="a s v by"
          style={{
            padding: isMobile ? '0rem' : '1.5rem',
            gap: isMobile ? 0 : '5rem',}}
        >
          <InitiativeSideBar />

          <div className="ap aa a b"
          >
            <DashboardNavBar
              initiativeDashboard={true}
              style={{ backgroundColor: 'var(--palette-white)' }}
            />
            <div className="n ap c3"
            >
              <div className="n a b fs d5 gm gn go"
                style={{
                  gap: gap,
                  paddingInline: isMobile ? '1rem' : 0,}}
              >
                {children}
              </div>
            </div>
          </div>
        </div>
      </Column>
    </ClientOnly>
  )
}
